// Recursively removes null items from an object.  Useful for cleaning graphQl mutations
export const removeNullFromObject = <T extends Record<string, any>>(obj: T): T => {
  return Object.fromEntries(
    Object.entries(obj)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, v]) => v != null)
      .map(([k, v]) => [k, v === Object(v) ? removeNullFromObject(v) : v]),
  ) as T;
};
